import React, { useId } from "react";
import { Search, X } from "lucide-react";
import styles from "./SearchInput.module.scss";

/**
 * SearchInput — design-system primitive (DESIGN.md §2 input sözleşmesi).
 *
 * Props:
 *   - value: string
 *   - onChange: (string) => void
 *   - placeholder?: string  (default "Ara…")
 *   - size?: "sm" | "md"     (default "sm")
 *   - clearable?: boolean    (default true; value boşsa zaten gizli)
 *   - className?: string
 *   - inputProps?: <input> üzerine spread (autoFocus, name, vs.)
 *   - ariaLabel?: string     (input için screen-reader label)
 *
 * Token'lar: --ds-bg/border/text/text-muted/info, --rad-md, --sp-*, dur/ease.
 * Dark-mode: body.dark-only altında token'lar otomatik geçer.
 */
const SearchInput = ({
  value = "",
  onChange,
  placeholder = "Ara…",
  size = "sm",
  clearable = true,
  className = "",
  inputProps = {},
  ariaLabel,
}) => {
  const id = useId();
  const showClear = clearable && value && value.length > 0;
  const sizeCls = size === "md" ? styles.md : styles.sm;

  return (
    <div className={`${styles.root} ${sizeCls} ${className}`}>
      <span className={styles.icon} aria-hidden="true">
        <Search size={size === "md" ? 18 : 16} />
      </span>
      <input
        {...inputProps}
        id={inputProps.id || id}
        type="search"
        className={styles.input}
        value={value ?? ""}
        onChange={(e) => onChange?.(e.target.value)}
        placeholder={placeholder}
        aria-label={ariaLabel || placeholder}
      />
      {showClear && (
        <button
          type="button"
          className={styles.clear}
          onClick={() => onChange?.("")}
          aria-label="Aramayı temizle"
        >
          <X size={size === "md" ? 16 : 14} />
        </button>
      )}
    </div>
  );
};

export default SearchInput;
